import React, { useState } from 'react';
import {Box, TextField} from '@mui/material';
import { LongTextQuestion } from 'crqlar-react-common/dist/models/forms/form';
import EditableTypography from 'crqlar-react-common/dist/components/EditableTypography';
import MdEditor from 'crqlar-react-common/dist/components/MdEditor';
import {useTranslation} from 'react-i18next';

interface LongTextEditorProps {
    question: LongTextQuestion;
    onQuestionUpdate: (question: LongTextQuestion) => void;
}

const LongTextEditor: React.FC<LongTextEditorProps> = ({
                                                           question,
                                                           onQuestionUpdate
                                                       }) => {
    const {t} = useTranslation();
    const [isEditingPlaceholder, setIsEditingPlaceholder] = useState(false);

    // Handle title update
    const handleTitleUpdate = (title: string) => {
        onQuestionUpdate({
            ...question,
            title
        });
    };

    // Handle description update
    const handleDescriptionUpdate = (description?: string) => {
        onQuestionUpdate({
            ...question,
            description: description || ''
        });
    };

    // Handle placeholder update
    const handlePlaceholderUpdate = (e: React.ChangeEvent<HTMLInputElement>) => {
        onQuestionUpdate({
            ...question,
            placeholder: e.target.value,
        });
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                p: 2,
            }}
        >
            {/* Title */}
            <EditableTypography
                value={question.title}
                onChange={handleTitleUpdate}
                multiline
                variant="h6"
                sx={{
                    mb: 2,
                    width: '100%',
                    fontWeight: 'medium',
                    textAlign: 'left',
                    padding: '8px',
                    borderRadius: 1,
                }}
                placeholder={t('Long question here')}
            />

            {/* Description */}
            <Box sx={{mb: 3, width: '100%'}}>
                <MdEditor
                    value={question.description || ''}
                    onChange={handleDescriptionUpdate}
                    placeholder={t('Question description (optional)')}
                    className={'mini-mdx'}
                />
            </Box>

            {/* Text Input Field */}
            <Box
                sx={{ width: '100%' }}
                onMouseEnter={() => setIsEditingPlaceholder(true)}
                onMouseLeave={() => setIsEditingPlaceholder(false)}
            >
                {isEditingPlaceholder ? (
                    <TextField
                        value={question.placeholder || ''}
                        onChange={handlePlaceholderUpdate}
                        variant="outlined"
                        fullWidth
                        multiline
                        rows={4}
                        label={t('Placeholder text')}
                        autoFocus
                        sx={{borderRadius: 1}}
                    />
                ) : (
                    <TextField
                        disabled
                        placeholder={question.placeholder || t('Type your detailed response here...')}
                        variant="outlined"
                        fullWidth
                        multiline
                        rows={4}
                        sx={{
                            cursor: 'pointer',
                            borderRadius: 1,
                        }}
                    />
                )}
            </Box>
        </Box>
    );
};

export default LongTextEditor;
